import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Button } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { TextAreaField } from 'components';
import { ReactComponent as CheckVerify } from 'assets/icons/checkVerify.svg';
import { ReactComponent as CheckVerifyBlue } from 'assets/icons/checkVerifyBlue.svg';
import { ReactComponent as WarningV2 } from 'assets/icons/warning-red-v2.svg';
import { voucherAuditorSetAuditStatus } from 'store/forms/actions';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { updateFormField } from 'store/forms/actions';
import { isEmpty } from 'lodash';

const VoucherAuditModal = (
  { 
    error, 
    openApproveAuditModal,
    setOpenApproveAuditModal,
    openAuditRejectModal,
    setOpenAuditRejectModal,
    openApproveBasedOnDocAuditModal,
    setOpenApproveBasedOnDocAuditModal,
  }) => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const legalVat = useSelector(state => state.forms.carrier.legalVat);
  const voucherInfo = useSelector(state => state.forms?.supplier?.voucherInfo);
  const [errorModal, setErrorModal] = useState(false);
  const [commentVoucherAuditor, setCommentVoucherAuditor] = useState('');
  
  //----------------------------  AUDITOR EDIT STATUS ACTION -------------------------------\\
  const handleSetAuditStatus = () => {
    const payload = {
            voucherCode: voucherInfo?.voucher?.code || '',
            supplierVatId: params?.supplierVat,
            auditStatus: openApproveAuditModal ? "INITIAL_CHECK_PASS" : openAuditRejectModal ? "INITIAL_CHECK_FAIL" : "ACCEPTED_INVOICE",
            comment:
            (openApproveAuditModal || openApproveBasedOnDocAuditModal) &&
            commentVoucherAuditor?.trim() === ''? '-' : commentVoucherAuditor,
          };
    dispatch(voucherAuditorSetAuditStatus({params: payload}));
  };

 const handleCloseError = () => {
    setErrorModal(false);
    if(error){
        dispatch(
          updateFormField({
            group: 'supplier',
            key: 'error',
            value: null,
          })
        )

    navigate('/appTrack');
  };
 };

  useEffect(()=>{
    if(error){
      if(openApproveAuditModal) setOpenApproveAuditModal(false);
      else if (openAuditRejectModal) setOpenAuditRejectModal(false);
      else setOpenApproveBasedOnDocAuditModal(false);

      setErrorModal(true);
    }
  },[error])

  const resetStates = () => {
    setCommentVoucherAuditor('');  
    
    if(openApproveAuditModal) setOpenApproveAuditModal(false);
    else if (openAuditRejectModal) setOpenAuditRejectModal(false);
    else setOpenApproveBasedOnDocAuditModal(false);
  }
  

return (
    <>
      <Modal
        centered
        width={400}
        open={errorModal}
        onCancel={() => setErrorModal(false)}
        onOk={() => setErrorModal(false)}
        closable={false}
        footer={null}
        maskClosable={false}
      > 
        <div className='mt-2 mb-2 color-red' style={{textAlign: 'center' }}>
          <WarningV2/>
          <p>{error?.responseDescription}</p>
        </div>
        <div  style={{display: 'flex', justifyContent: 'center'}}>
          <Button
            type="default"
            className={"ant-btn-primary return-btn"}
            label={'Κλείσιμο'}
            onClick={handleCloseError}
          />
        </div>
      </Modal>

      <Modal
        centered
        width={400}
        open={openApproveAuditModal || openAuditRejectModal || openApproveBasedOnDocAuditModal}
        onCancel={resetStates}
        onOk={resetStates}
        closable={false}
        footer={null}
        maskClosable={false}
      > 
            { openApproveAuditModal && 
            <div>
              <CheckVerify/>
                  <h2 className={'font-size-18'} style={{ marginTop: 10}}>
                   Ώριμη προς έλεγχο
                  </h2>
                  <p style={{ textAlign: 'left' }}>Με την ενέργεια αυτή πρόκειται να εγκρίνεται την πληρωμή για το παρών voucher. Η ενέργεια είναι μη αναστρέψιμη.</p>
                  <div className="mt-2">
                  {/* <TextAreaField
                    label={'Σχόλιο'}
                    placeholder={'Προσθήκη Σχολίου'}
                    asterisk={false}
                    name={'commentVoucherAuditor'}
                    value={commentVoucherAuditor}
                    maxLength={1000}
                    onChange={event =>
                      setCommentVoucherAuditor(event.target.value)
                    }
                    /> */}
                </div>
            </div>
            }
            { openApproveBasedOnDocAuditModal && 
            <div>
              <CheckVerifyBlue/>
                  <h2 className={'font-size-18'} style={{ marginTop: 10}}>
                    Έγκριση πληρωμής βάση παραστατικού
                  </h2>
                  <p style={{ textAlign: 'left' }}>Με την ενέργεια αυτή πρόκειται να εγκρίνεται την πληρωμή για το παρών voucher. Η ενέργεια είναι μη αναστρέψιμη.</p>
                  <div className="mt-2">
                  <TextAreaField
                    label={'Σχόλιο'}
                    placeholder={'Προσθήκη Σχολίου'}
                    asterisk={false}
                    name={'commentVoucherAuditor'}
                    value={commentVoucherAuditor}
                    maxLength={1000}
                    onChange={event =>
                      setCommentVoucherAuditor(event.target.value)
                    }
                    />
                </div>
            </div>
            }
            { openAuditRejectModal &&
            <div>
              <WarningV2/>
              <h2 className={'font-size-18'} style={{ marginTop: 10}}>
                Εκκρεμότητα κατόπιν Τυπικού Ελέγχου
              </h2>
              <p style={{ textAlign: 'left' }}>Με την ενέργεια αυτή πρόκειται να απορρίψετε την πληρωμή για το παρών voucher. Η ενέργεια είναι μη αναστρέψιμη </p>
              <TextAreaField
                label={'Σχόλιο'}
                placeholder={'Προσθήκη Σχολίου'}
                asterisk={true}
                name={'commentVoucherAuditor'}
                value={commentVoucherAuditor}
                maxLength={1000}
                onChange={event =>
                  setCommentVoucherAuditor(event.target.value)
                }
              />
            </div>
          }
          <div className='modal-buttons-container'>
            <Button
              type="default"
              className={"ant-btn-primary return-btn"}
              label={'Απόρριψη'}
              onClick={resetStates}
            />
            <Button
              type="default"
              // disabled={isEmpty(commentVoucherAuditor)}
              disabled={(openApproveAuditModal || openApproveBasedOnDocAuditModal)? false: (commentVoucherAuditor?.trim() === '')}
              className={`ant-btn-primary ${openApproveAuditModal ? 'verify-btn' : openApproveBasedOnDocAuditModal ? 'verify-btn-v2' : 'reject-btn-2'}`}
              label={'Επιβεβαίωση'}
              onClick={handleSetAuditStatus}
            />
          </div>
        </Modal>
    </>
  );
};

export default VoucherAuditModal;